(ns app.domain.sign-off.legacy-declarations
  "DEPRECATED: Generate declaration statements for sign-offs (both the web UI and the PDF render).")

(def h2-props {:class "mb-2 mt-8 text-sm uppercase leading-tight font-semibold"})
(def h3-props {:class "mb-3 text-sm leading-tight font-semibold"})
(defn p-props
  ([]
   (p-props ""))
  ([class]
   {:class (str "p-0 leading-tight " class)}))

(def declarations
  {:permit-type/B {:role/applicant (fn [full-name tr]
                                     [:div
                                      [:h2 h2-props (tr [:role/applicant])]
                                      [:p (p-props "mt-4") (tr [:sign-off/declaration] [full-name])]])}
   :permit-type/P {:rezoning-affidavit  {:role/applicant      (fn [_ tr]
                                                                [:div
                                                                 [:h2 h2-props (tr [:role/applicant])]
                                                                 [:h3 h3-props (tr [:sign-off.planning/personal-info-title])]
                                                                 [:p (p-props "mb-5") (tr [:sign-off.planning/personal-info-body])]
                                                                 [:h3 h3-props (tr [:sign-off.planning/species-at-risk-title])]
                                                                 [:p (p-props "mb-3") (tr [:sign-off.planning/species-at-risk-body])]
                                                                 [:p (p-props) (tr [:sign-off.planning/species-at-risk-ack])]])
                                         :role/agent          (fn [full-name tr]
                                                                [:div
                                                                 [:h2 h2-props (tr [:role/agent])]
                                                                 (if full-name
                                                                   [:div
                                                                    [:h3 h3-props (tr [:sign-off.planning/personal-info-title])]
                                                                    [:p (p-props) (tr [:sign-off.planning/personal-info-body])]]
                                                                   [:p (p-props "mt-4") (tr [:sign-off/no-parties-found] [(tr [:role/agent])])])])
                                         :role/property-owner (fn [full-name tr]
                                                                [:div
                                                                 [:h2 h2-props (tr [:role/property-owner])]
                                                                 (if full-name
                                                                   [:div
                                                                    [:h3 h3-props (tr [:sign-off.planning/personal-info-title])]
                                                                    [:p (p-props "mb-5") (tr [:sign-off.planning/personal-info-body])]
                                                                    [:h3 h3-props (tr [:sign-off.planning/permission-for-subject-land-title])]
                                                                    [:p (p-props) (tr [:sign-off.planning/permission-for-subject-land-body])]]
                                                                   [:p (p-props "mt-4") (tr [:sign-off/no-parties-found] [(tr [:role/property-owner])])])])}
                   :role/applicant      (fn [full-name tr]
                                          [:div
                                           [:h2 h2-props (tr [:role/applicant])]
                                           [:p (p-props "mt-6 mb-5") (tr [:sign-off.planning/declaration] [full-name (tr [:role/applicant])])]
                                           [:h3 h3-props (tr [:sign-off.planning/personal-info-title])]
                                           [:p (p-props "mb-5") (tr [:sign-off.planning/personal-info-body])]
                                           [:h3 h3-props (tr [:sign-off.planning/species-at-risk-title])]
                                           [:p (p-props "mb-3") (tr [:sign-off.planning/species-at-risk-body])]
                                           [:p (p-props) (tr [:sign-off.planning/species-at-risk-ack])]])
                   :role/agent          (fn [full-name tr]
                                          [:div
                                           [:h2 h2-props (tr [:role/agent])]
                                           (if full-name
                                             [:div
                                              [:p (p-props "mt-6 mb-5") (tr [:sign-off.planning/declaration] [full-name (tr [:role/agent])])]
                                              [:h3 h3-props (tr [:sign-off.planning/personal-info-title])]
                                              [:p (p-props) (tr [:sign-off.planning/personal-info-body])]]
                                             [:p (p-props "mt-4") (tr [:sign-off/no-parties-found] [(tr [:role/agent])])])])
                   :role/property-owner (fn [full-name tr]
                                          [:div
                                           [:h2 h2-props (tr [:role/property-owner])]
                                           (if full-name
                                             [:div
                                              [:p (p-props "mt-6 mb-5") (tr [:sign-off.planning/declaration] [full-name (tr [:role/property-owner])])]
                                              [:h3 h3-props (tr [:sign-off.planning/personal-info-title])]
                                              [:p (p-props "mb-5") (tr [:sign-off.planning/personal-info-body])]
                                              [:h3 h3-props (tr [:sign-off.planning/permission-for-subject-land-title])]
                                              [:p (p-props) (tr [:sign-off.planning/permission-for-subject-land-body])]]
                                             [:p (p-props "mt-4") (tr [:sign-off/no-parties-found] [(tr [:role/property-owner])])])])}})


(defn role->declaration
  "Deprecated hard-coded declarations, used only for legacy data."
  ([permit-type role-key]
   (role->declaration permit-type role-key nil))
  ([permit-type role-key schema-name]
   (or (get-in declarations
               [permit-type schema-name role-key])
       (get-in declarations
               [permit-type role-key])
       (fn [_ tr]
         [:div
          [:h2 h2-props
           ;; Only hardcoded roles can be defaults so this localization is fine
           (tr [role-key])]]))))


(defn editor-preview-schema [tr role-key]
  [:div
   [:h2 h2-props (tr [role-key])]
   [:p (p-props "mt-4") (tr [:sign-off/declaration-placeholder]
                            [(tr [role-key])])]])
